import { BaseContextImpl, BaseContext } from './basecontext';
import { RouterDataModelProps } from './routerbuilder';


export class ContextManager
{
    private static APPLICATION_CONTEXT: BaseContextImpl;

    static createContext(routerDataModelProps: RouterDataModelProps, resourcedLoaded: () => void)
    {
        if(this.APPLICATION_CONTEXT === undefined)
        {
            this.APPLICATION_CONTEXT = new BaseContextImpl();

            this.APPLICATION_CONTEXT.init(resourcedLoaded);
            this.APPLICATION_CONTEXT.fromRoutingProps(routerDataModelProps);
        }
    }

    static createUserContext()
    {
        this.APPLICATION_CONTEXT.setUserContext(this.APPLICATION_CONTEXT.getUserContext());
    }

    static getContext(): BaseContext
    {
      return this.APPLICATION_CONTEXT;   
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/contextmanager.ts